import React from "react"

export default function Pin() {
   return (
      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
         <g clipPath="url(#clip0_112_19345)">
            <path d="M12.4182 8.23751L12.0956 5.11914H13.2085C13.558 5.11914 13.8413 4.83583 13.8413 4.48633V3.2207C13.8413 2.87121 13.558 2.58789 13.2085 2.58789H6.03662C5.68712 2.58789 5.40381 2.87121 5.40381 3.2207V4.48633C5.40381 4.83583 5.68712 5.11914 6.03662 5.11914H7.1495L6.8269 8.23751C5.54791 8.83217 4.56006 9.89848 4.56006 11.2363C4.56006 11.5858 4.84337 11.8691 5.19287 11.8691H8.77881V14.6115C8.77881 14.6443 8.78643 14.6766 8.80109 14.7059L9.4339 15.9715C9.51145 16.1266 9.73354 16.1269 9.81124 15.9715L10.4441 14.7059C10.4587 14.6766 10.4663 14.6443 10.4663 14.6115V11.8691H14.0523C14.4018 11.8691 14.6851 11.5858 14.6851 11.2363C14.6851 9.88678 13.6836 8.82584 12.4182 8.23751Z" fill="#5B5E71" />
         </g>
         <defs>
            <clipPath id="clip0_112_19345">
               <rect width="10.125" height="13.5" fill="white" transform="translate(4.56006 2.58789)" />
            </clipPath>
         </defs>
      </svg>
   )
}